import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { calentarConexion } from './api';
import './estilos.css';

// Se abre la conexion con la API mientras la pantalla de ingreso se dibuja:
// asi el primer golpe —el que falla— lo paga la aplicacion y no la persona
// escribiendo su contrasena. Ver `calentarConexion`.
calentarConexion();

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      // Son seis usuarios y los datos cambian poco: recargar cada vez que se
      // vuelve a la pestaña molesta más de lo que ayuda.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('no existe el nodo #raiz');

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={cliente}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
